<template>
  <div>
    <b-row class="mb-2">
      <!-- Sorting Card -->
      <b-col
        md="12"
        xl="6"
        class="mb-2 mb-xl-0"
      >
        <b-card class="h-100 mb-0">
          <div class="d-flex justify-content-between align-items-center mb-0 pb-0">
            <div class="d-flex align-items-center">
              <mdicon
                name="FilterVariant"
                size="18"
                class="mr-50 text-secondary"
              />
              <h5 class="mb-0 text-secondary font-weight-bolder">
                Sorting
              </h5>
            </div>
          </div>
          <b-row class="mt-1">
            <!--Freeze Merchant dropdown-->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Merchant"
                label-for="freeze-merchant"
                class="mb-1"
              >
                <v-select
                  id="freeze-merchant"
                  v-model="filters['merchant_id']"
                  :options="merchantOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Merchant"
                  :disabled="freezeMerchantCheckbox"
                  @input="handleMerchantChange()"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
              <div class="d-flex align-items-center justify-content-between">
                <b-form-checkbox
                  v-model="freezeMerchantCheckbox"
                  :disabled="!filters.merchant_id"
                >
                  Freeze Merchant
                </b-form-checkbox>

              </div>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Merchant Business"
                label-for="merchant business"
                class="mb-1 mt-2 mt-md-0"
              >
                <v-select
                  v-model="filters['orderable_id']"
                  :options="merchantBusinessOptions"
                  :reduce="option => option.id"
                  label="business_name"
                  placeholder="Select Merchant Business"
                  :disabled="!filters['merchant_id'] || (filters['merchant_id'] && freezeMerchantCheckbox)"
                  @input="fetchActiveBag()"
                >
                  <template v-slot:option="option">
                    {{ option.business_name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <!-- Bag Management Card -->
      <b-col
        md="12"
        xl="6"
      >
        <b-card class="h-100 mb-0">
          <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center mb-2">
            <div class="d-flex align-items-center mb-1 mb-sm-0">
              <feather-icon
                icon="BriefcaseIcon"
                size="18"
                class="mr-50 text-secondary"
              />
              <h5 class="mb-0 text-secondary font-weight-bolder">
                Bag Management
              </h5>
            </div>

            <!-- Action Buttons (Styled like Invoices) -->
            <div class="d-flex flex-column flex-sm-row">
              <b-button
                v-if="status_key === 'key_20' && activeBagName && freezeMerchantCheckbox"
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="danger"
                class="font-weight-bold mb-1 mb-sm-0 mr-sm-1"
                @click="closeActiveBag"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="mr-25"
                />
                Close Bag
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="custom-button-color font-weight-bold"
                :disabled="!filters.merchant_id || !filters.orderable_id || !freezeMerchantCheckbox"
                @click="openCreateBagModal"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="14"
                  class="mr-25"
                />
                Add New Bag
              </b-button>
            </div>
          </div>

          <div v-if="status_key === 'key_20' && activeBagName && freezeMerchantCheckbox">
            <b-row>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-card
                  no-body
                  class="border mb-0"
                  border-variant="primary"
                >
                  <b-card-body class="p-1 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center overflow-hidden flex-grow-1 mr-1">
                      <b-avatar
                        rounded
                        size="42"
                        style="background-color: #67b7b7;"
                        class="mr-1 flex-shrink-0"
                      >
                        <feather-icon
                          icon="BriefcaseIcon"
                          size="18"
                          class="text-white"
                        />
                      </b-avatar>
                      <div class="overflow-hidden">
                        <h6 class="mb-0 text-muted font-weight-bold text-uppercase">
                          BAG ID
                        </h6>
                        <small
                          class="font-weight-bolder text-dark text-truncate d-block"
                          :title="activeBagName"
                        >
                          {{ activeBagName }}
                        </small>
                      </div>
                    </div>
                    <b-button
                      v-b-tooltip.hover.v-primary
                      :title="bagIdTooltip"
                      variant="primary"
                      class="btn-icon rounded flex-shrink-0"
                      size="sm"
                      @click="copyToClipboard(activeBagName, 'bag')"
                    >
                      <feather-icon
                        icon="CopyIcon"
                        size="16"
                      />
                    </b-button>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12">
                <b-card
                  no-body
                  class="border mb-0"
                >
                  <b-card-body class="p-1 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center overflow-hidden flex-grow-1 mr-1">
                      <b-avatar
                        rounded
                        size="42"
                        style="background-color: #6a76b0;"
                        class="mr-1 flex-shrink-0"
                      >
                        <span
                          class="text-white font-weight-bolder"
                          style="font-size: 1.2rem;"
                        >#</span>
                      </b-avatar>
                      <div class="overflow-hidden">
                        <h6 class="mb-0 text-muted font-weight-bold text-uppercase">
                          CUSTOM ID
                        </h6>
                        <small
                          class="font-weight-bolder text-dark text-truncate d-block"
                          :title="customIdText || 'N/A'"
                        >
                          {{ customIdText || 'N/A' }}
                        </small>
                      </div>
                    </div>
                    <b-button
                      v-b-tooltip.hover.v-primary
                      :title="customIdTooltip"
                      variant="primary"
                      class="btn-icon rounded flex-shrink-0"
                      size="sm"
                      :disabled="!customIdText"
                      @click="copyToClipboard(customIdText, 'custom')"
                    >
                      <feather-icon
                        icon="CopyIcon"
                        size="16"
                      />
                    </b-button>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <div
            v-else-if="!filters.merchant_id || !filters.orderable_id || !freezeMerchantCheckbox"
            class="d-flex align-items-center justify-content-center mt-2 h-50 text-muted text-center p-1"
          >
            Freeze a merchant and merchant business to create or view a bag
          </div>
          <div
            v-else
            class="d-flex align-items-center justify-content-center mt-2 h-50 text-muted"
          >
            No active bag found.
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-card class="mb-2">
      <b-row>
        <b-col>
          <form-builder
            ref="formbuilder"
            v-model="formData"
            :on-submit="onSubmit"
            grid-class="row"
            :form-structure="formStructure"
            @waybillPaste="handleWaybillPaste"
            @waybillScan="getScanOrderDetails"
          >
            <template slot="buttons">
              <b-row>
                <b-col>
                  <b-button
                    type="submit"
                    class="vh-5 mt-2 ml-1 ml-md-1 custom-button-color"
                    :disabled="!(formData.waybill_number) || loadingResponse || !filters.merchant_id || !filters.orderable_id || !activeBagId || !freezeMerchantCheckbox"
                    @click="onSubmit"
                  >
                    {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </form-builder>
          <b-form-checkbox
            v-model="auto_submit"
            :value="true"
            class="mt-sm-1"
          >
            <small>Auto Submit</small>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          md="3"
        >
          <b-form-group
            label="Received Date"
            label-for="basicInput"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'right'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </FilterCard>
    <b-card no-body>
      <div class="m-2">
        <b-row cols="12">
          <b-col
            md="12"
            lg="4"
            class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
          />
          <b-col
            class="d-flex align-items-center justify-content-center mb-1 mb-md-0"
          >
            <b-button
              type="submit"
              class="custom-button-color-blur"
              :disabled="false"
            >
              Scanned Orders : {{ submitCount }}
            </b-button>
          </b-col>
          <b-col
            class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
          >
            <ReportTableButtons
              :items="rows"
              :json_fieldz="json_fields"
              :name="`ReturnToClient - Page ${page}.xls`"
              :bulkname="`ReturnToClient.xls`"
              :fetch="getOrderListNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>

      </div>

      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowDownIcon'
                      : 'ArrowUpIcon'"
                    size="14"
                  />
                </div>
              </template>

              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.customer_name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary text-pointer"
                      @click="onClickViewOrderModal(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ __orderMerchantName(data.item) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.address)="data">
                <div class="d-flex align-items-start width-150">
                  <div>
                    <div class="">
                      {{ (data.item.merchant_business.pickup_address) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.customer_name }}
                    </div>
                    <div class="font-small-2">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.destination_city.name }}
                      <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(finance)="data">
                <div
                  v-if="__getMerchantType(data.item) !== 'WC'"
                  class="width-150"
                >
                  <b>Total&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.cod, true) || '---' }}
                  <div style="height:8px;" />
                  <b>Collected&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                </div>
                <div
                  v-else
                  class="width-150"
                >
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                  <div style="height:8px;" />
                  <b>Advance&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>Balance&nbsp;:</b>&nbsp;&nbsp;{{ (data.item.delivery_charge - data.item.collected_cod ) || '---' }}
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>

              <!-- ... Flag Componant ... -->
              <template #cell(order_flags)="data">
                <div class="d-flex align-items-center">
                  <FlagDisplay :flags="data.item.order_flags" />
                </div>
              </template>

              <template #cell(status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    @click="onClickViewOrderModal(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-overlay>
          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <view-order-modal ref="viewOrderModal" />

    <!-- Create New Return Bag Modal -->
    <b-modal
      id="create-bag-modal"
      ref="createBagModal"
      title="Create New Bag"
      hide-footer
      centered
      modal-class="modal-create-bag"
    >
      <div class="p-1">
        <p class="text-muted font-small-3 mb-2">
          A bag groups returned parcels for a single merchant destination.
        </p>
        <b-form-group
          label="Bag ID"
          label-for="modal-bag-id"
          class="mb-2"
        >
          <b-form-input
            id="modal-bag-id"
            v-model="modalBagId"
            disabled
            class="bg-light text-muted font-weight-bold"
          />
        </b-form-group>
        <b-form-group
          label="Custom ID"
          label-for="modal-rt-id"
          class="mb-2"
        >
          <b-form-input
            id="modal-rt-id"
            v-model="modalRtId"
            placeholder="Enter Custom ID"
          />
        </b-form-group>
        <div class="d-flex justify-content-end align-items-center mt-3">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="closeCreateBagModal"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            :disabled="!modalRtId || modalRtId === 'RT-' || loadingBag"
            @click="submitCreateBag"
          >
            {{ loadingBag ? 'Creating...' : 'Create Bag' }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardBody,
  BButton,
  BFormGroup,
  BPagination,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  VBTooltip,
  BModal,
  BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'
import store from '@/store'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import FlagDisplay from '@/components/AllOrders/OrderFlags/FlagDisplay.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const orderRepository = RepositoryFactory.get('order')
const merchantRepository = RepositoryFactory.get('merchant')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const waybillSettingsRepository = RepositoryFactory.get('waybillSetting')
const sortingRepository = RepositoryFactory.get('sorting')

export default {
  name: 'ReturnSortingOperation',
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    AdvancedDateFilter,
    BAvatar,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    FormBuilder,
    BButton,
    BFormGroup,
    BPagination,
    BOverlay,
    OrderStatusBadge,
    BDropdown,
    BDropdownItem,
    ViewOrderModal,
    vSelect,
    FlagDisplay,
    FilterCard,
    BFormCheckbox,
    BModal,
    BFormInput,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      status_key: 'key_20',
      // Table Info
      freezeMerchantCheckbox: false,
      submitCount: 0,
      loadingResponse: false,
      filterAuto: true,
      avatarText,
      bagIdTooltip: 'Copy Bag ID',
      customIdTooltip: 'Copy Custom ID',
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      total: 0,
      cod: 0,
      meta: {},
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      dataLoading: false,
      sortDirection: 'asc',
      filterName: '',
      fields: [
        {
          key: 'waybill_number',
          label: 'WayBill Number',
          sortable: true,
        },
        {
          key: 'merchant.name',
          label: 'Merchant',
          sortable: true,
        },
        {
          key: 'merchant.address',
          label: 'Merchant Address',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'origin_warehouse',
          label: 'Origin',
          sortable: true,
        },
        {
          key: 'destination_warehouse',
          label: 'Destination',
          sortable: true,
        },
        {
          key: 'customer_email',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'finance',
          label: 'Finance',
          sortable: false,
        },
        {
          key: 'weight',
          label: 'Weight',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'order_flags',
          label: 'Flags',
          sortable: false,
        },
        {
          key: 'status.key',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        Merchant: 'merchant.name',
        'Merchant Address': {
          field: 'merchant_business.pickup_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`,
        },
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Phone': {
          field: 'customer_phone',
          callback: value => `"${value}"`,
        },
        'Second Phone Number': {
          field: 'customer_secondary_phone',
          callback: value => `"${value}"`,
        },
        COD: 'cod',
        'Collected Cod': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        Weight: 'weight',
        Flag: {
          field: 'order_flags',
          callback: value => {
            const flagNames = value.map(flag => flag.name).join(', ')
            return `"${flagNames}"`
          },
        },
        Status: {
          field: 'status.name',
          callback: value => `"${value}"`,
        },
      },
      rows: [],
      merchantOptions: [],
      // Form Info
      formData: {},
      riderOptions: [],
      orderSettings: null,
      settingWaybillLength: 0,
      auto_submit: false,
      waybillMaxLength: 0,
      merchantBusinessOptions: [],
      activeBagName: '',
      activeBagStatus: 'Open',
      activeBagId: null,
      loadingBag: false,
      modalBagId: '',
      modalRtId: 'RT-',
      customIdText: '',
    }
  },
  computed: {
    formStructure() {
      const isDisabled = !this.filters.merchant_id || !this.filters.orderable_id || !this.activeBagId || !this.freezeMerchantCheckbox
      return [
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Waybill Number',
          value: 'waybill_number',
          class: 'col-6 col-md-3',
          validation: 'required',
          disabled: isDisabled,
        },
      ]
    },
    appliedFilterCount() {
      if (!this.filterAuto) {
        return this.manualFilterCount
      }

      let count = 0
      Object.entries(this.filters).forEach(([key, value]) => {
        if (key === 'merchant_id' || key === 'orderable_id') return

        if (Array.isArray(value)) {
          if (value.length) count += 1
        } else if (typeof value === 'object' && value !== null) {
          if (value.startDate || value.endDate) count += 1
        } else if (
          value !== ''
          && value !== null
          && value !== undefined
          && value !== false
        ) {
          count += 1
        }
      })
      return count
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    page() {
      this.getOrderList()
    },
    perPage() {
      this.getOrderList()
    },
  },
  async mounted() {
    this.totalRows = this.rows.length
    await this.readOrderSetting()
    await this.getWaybillMaxLength()
    this.getMerchantList()
  },
  methods: {
    handleWaybillPaste(pastedText) {
      if (pastedText) {
        if (this.auto_submit) {
          setTimeout(() => {
            this.onSubmit()
          }, 0)
        }
      }
    },
    async getOrderDetails(waybill) {
      try {
        const { data } = (await orderRepository.fetchOrderData(waybill)).data
        this.order_merchant_id = data.merchant_id
        this.order_orderable_id = data.orderable_id
      } catch (e) {
        this.showErrorMessage('Check Waybill Number Again, Remove Spaces if there any!')
      }
    },
    async getScanOrderDetails(waybill) {
      if (waybill && this.auto_submit) {
        this.onSubmit()
      }
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await sortingRepository.getReturnReport(this.page, this.perPage, filterQuery))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await sortingRepository.getReturnReportNoPagination(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
        this.settingWaybillLength = this.orderSettings.waybill_setting.auto_waybill_prefix.length + Number(this.orderSettings.waybill_setting.digit_count)
        if (this.orderSettings.waybill_setting.suffix_enabled) this.settingWaybillLength += this.orderSettings.waybill_setting.auto_waybill_suffix.length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getWaybillMaxLength() {
      try {
        const maxWaybill = (await waybillSettingsRepository.getLongestWaybillNumberLength()).data.data
        this.waybillMaxLength = maxWaybill.max_length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantList() {
      try {
        this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await merchantRepository.getMerchantListForDropdown()).data.data
        if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantBusinessList() {
      try {
        if (this.filters.orderable_id) {
          this.filters.orderable_id = ''
        }
        const merchantID = this.filters.merchant_id
        const { data } = (await merchantRepository.getMerchantBusinessListDropdown(merchantID)).data
        this.merchantBusinessOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleMerchantChange() {
      this.getMerchantBusinessList()
      this.fetchActiveBag()
    },
    async fetchActiveBag() {
      this.activeBagId = null
      this.activeBagName = ''
      this.customIdText = ''
      this.activeBagStatus = 'Open'
      this.freezeMerchantCheckbox = false

      if (!this.filters.merchant_id || !this.filters.orderable_id) return

      try {
        const response = await sortingRepository.getActiveReturnBag(this.filters.merchant_id, this.filters.orderable_id)
        if (response && response.data && response.data.data) {
          const bagData = response.data.data
          this.activeBagId = bagData.id
          this.activeBagName = bagData.bag_number.replace('R-BAG-', 'BAG-')
          this.customIdText = bagData.custom_id || ''
          this.activeBagStatus = bagData.is_closed ? 'Closed' : 'Open'
          this.freezeMerchantCheckbox = true
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          // No active bag found, which is completely fine
        } else {
          this.convertAndNotifyError(e)
        }
      }
    },
    async onSubmit() {
      this.loadingResponse = true
      try {
        if (this.freezeMerchantCheckbox === true) {
          await this.getOrderDetails(this.formData.waybill_number)
          if (this.order_merchant_id !== this.filters.merchant_id || (this.filters.orderable_id && this.order_orderable_id !== this.filters.orderable_id)) {
            this.loadingResponse = false
            this.$nextTick(() => {
              this.$refs.formbuilder.reset()
              // eslint-disable-next-line no-underscore-dangle
              this.__focusInputField('Waybill Number')
            })
            this.errMsg = 'The merchant business of the order and the freeze merchant business is not same, Please disable the freeze Merchant or change the freeze merchant business to the merchant business of the order.'
            if (this.order_merchant_id !== this.filters.merchant_id) {
              this.errMsg = 'The merchant of the order and the freeze merchant is not same, Please disable the freeze merchant or change the freeze merchant to the merchant of the order.'
            }
            this.showErrorMessage(this.errMsg)
            return
          }
        }
        const payload = {
          waybill_numbers: [],
        }
        payload.waybill_numbers.push(this.formData.waybill_number)
        payload.status_key = this.status_key
        payload.other_details = {}
        if (this.activeBagId) {
          payload.other_details.sorting_bag_id = this.activeBagId
        }
        const response = await sortingRepository.orderBulkReturnStatusUpdate(payload)
        this.$refs.formbuilder.reset()
        // await this.getOrderList()
        this.showSuccessMessage(response?.data?.message || 'Order updated successfully')
        this.submitCount += 1
        // eslint-disable-next-line no-underscore-dangle
        this.__focusInputField('Waybill Number')
      } catch (e) {
        this.loadingResponse = false
        this.$nextTick(() => {
          this.$refs.formbuilder.reset()
          // eslint-disable-next-line no-underscore-dangle
          this.__focusInputField('Waybill Number')
        })
        this.convertAndNotifyError(e)
      }
      this.loadingResponse = false
    },
    onClickViewOrderModal(id) {
      this.$refs.viewOrderModal.openModal(id)
    },

    filterQueryUpdate() {
      this.getOrderList()
    },
    handleChangePage(page) {
      this.page = page
      this.getOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchOrderList()
      }
    },
    onClickRefresh() {
      this.getOrderList()
    },

    async openCreateBagModal() {
      if (!this.filters.merchant_id || !this.filters.orderable_id) {
        this.showErrorMessage('Please select a Merchant and Merchant Business first')
        return
      }

      try {
        this.loadingBag = true
        const response = await sortingRepository.getNextReturnBagId(this.filters.merchant_id, this.filters.orderable_id)
        if (response && response.data && response.data.data) {
          this.modalBagId = response.data.data.next_bag_id
        }
      } catch (e) {
        this.convertAndNotifyError(e)
        return
      } finally {
        this.loadingBag = false
      }

      this.modalRtId = ''
      this.$refs.createBagModal.show()
    },
    async closeActiveBag() {
      const confirm = await this.$swal({
        title: 'Are you sure?',
        text: 'Do you really want to close this bag?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, close it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })

      if (confirm.value) {
        this.loadingBag = true
        try {
          const payload = {
            merchant_id: this.filters.merchant_id,
            merchant_business_id: this.filters.orderable_id,
          }
          await sortingRepository.closeReturnBag(payload)
          this.showSuccessMessage('Bag closed successfully')
          this.activeBagId = null
          this.activeBagName = ''
          this.customIdText = ''
          this.activeBagStatus = 'Closed'
        } catch (e) {
          this.convertAndNotifyError(e)
        } finally {
          this.loadingBag = false
        }
      }
    },
    closeCreateBagModal() {
      this.$refs.createBagModal.hide()
    },

    async submitCreateBag() {
      this.loadingBag = true
      try {
        const payload = {
          merchant_id: this.filters.merchant_id,
          merchant_business_id: this.filters.orderable_id,
          status_key: this.status_key,
          bag_id: this.modalBagId,
          custom_id: this.modalRtId,
        }
        const response = await sortingRepository.createReturnBag(payload)
        if (response && response.data && response.data.data) {
          const bagData = response.data.data
          this.activeBagId = bagData.id
          this.activeBagName = bagData.display_name
          this.activeBagStatus = bagData.status || 'Open'
          this.freezeMerchantCheckbox = true
          this.showSuccessMessage('New bag created successfully!')
        } else {
          this.activeBagId = null
          this.activeBagName = this.modalBagId
          this.activeBagStatus = 'Open'
          this.freezeMerchantCheckbox = true
          this.showSuccessMessage('New bag created successfully!')
        }
        this.closeCreateBagModal()
        await this.fetchActiveBag()
      } catch (err) {
        this.convertAndNotifyError(err)
      } finally {
        this.loadingBag = false
      }
    },
    async copyToClipboard(text, type) {
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
        if (type === 'bag') {
          this.bagIdTooltip = 'Copied!'
          setTimeout(() => { this.bagIdTooltip = 'Copy Bag ID' }, 2000)
        } else {
          this.customIdTooltip = 'Copied!'
          setTimeout(() => { this.customIdTooltip = 'Copy Custom ID' }, 2000)
        }
      } catch (err) {
        this.showErrorMessage('Failed to copy to clipboard')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-light-bag {
  background-color: #f4f7fd;
  border-color: #ebe9f1 !important;
}
</style>
